<template>
  <div>
    <el-group-title title="财务信息" class="d_jump" index="moneyInfo">
      <template slot="groupTitle">
        <el-form
          :model="form"
          :rules="rules"
          ref="form"
          label-width="160px"
          class="ccui-form demo-form-inline"
          :inline="true"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="价格地区：" prop="priceRegion">
                <el-select
                  v-model="form.priceRegion"
                  class="ccui-form-longInput"
                  placeholder="请选择"
                >
                  <el-option label="北京" value="1"></el-option>
                  <el-option label="上海" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="计税方法：" prop="taxMethod">
                <el-input
                  v-model="form.taxMethod"
                  class="ccui-form-longInput"
                  placeholder="请输入计税方法"
                  clearable
                  maxlength="15"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="发票类型：" prop="taxType">
                <el-select
                  v-model="form.taxType"
                  class="ccui-form-longInput"
                  placeholder="请选择"
                >
                  <el-option label="增值税" value="1"></el-option>
                  <el-option label="一般" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="签订地点：" prop="placeSign">
                <el-input
                  v-model="form.placeSign"
                  class="ccui-form-longInput"
                  placeholder="请输入"
                  clearable
                  maxlength="15"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="合同份数：" prop="numberCopies">
                <el-input
                  v-model="form.numberCopies"
                  class="ccui-form-longInput"
                  placeholder="请输入"
                  clearable
                  maxlength="15"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="对方联系人：" prop="phonePerson">
                <el-input
                  v-model="form.phonePerson"
                  class="ccui-form-longInput"
                  placeholder="请输入"
                  clearable
                  maxlength="15"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="供应商纳税人类型：" prop="taxpayer">
                <el-select
                  v-model="form.taxpayer"
                  class="ccui-form-longInput"
                  placeholder="请选择"
                >
                  <el-option label="一般纳税人" value="1"></el-option>
                  <el-option label="特殊纳税人" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="物资来源：" prop="materialSources">
                <el-input
                  v-model="form.materialSources"
                  class="ccui-form-longInput"
                  placeholder="请输入"
                  clearable
                  maxlength="15"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="支付系数：" prop="paymentCoefficient">
                <el-input
                  v-model="form.paymentCoefficient"
                  class="ccui-form-longInput"
                  placeholder="请输入"
                  clearable
                  maxlength="15"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="预付款：" prop="advanceCharge">
                <el-input
                  v-model="form.advanceCharge"
                  class="ccui-form-longInput"
                  placeholder="请输入"
                  clearable
                  maxlength="15"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="预付款：" prop="advanceCharge">
                <el-input
                  v-model="form.advanceCharge"
                  class="ccui-form-longInput"
                  placeholder="请输入"
                  clearable
                  maxlength="15"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="账户名称：" prop="titleAccount">
                <el-select
                  v-model="form.titleAccount"
                  class="ccui-form-longInput"
                  placeholder="请选择"
                >
                  <el-option label="北京银行" value="1"></el-option>
                  <el-option label="建设银行" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="开户行账号：" prop="accountNumber">
                <el-input
                  v-model="form.accountNumber"
                  class="ccui-form-longInput"
                  placeholder="请输入"
                  clearable
                  maxlength="15"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户行名称：" prop="accountName">
                <el-input
                  v-model="form.accountName"
                  class="ccui-form-longInput"
                  placeholder="请输入"
                  clearable
                  maxlength="15"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>
    </el-group-title>
  </div>
</template>

<script>
import Cookies from "js-cookie";

export default {
  name: "financeInfo",
  props: {
    financeInfo: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      form: {
        textName: "", //合同附件里的文件名称
        txtlarge: "", //合同附件里的文件大小
        priceRegion: "", //财务信息里的价格地区
        taxMethod: "", //计税方法
        taxType: "", //发票类型
        placeSign: "", //签订地点
        numberCopies: "", //合同份数
        phonePerson: "", //对方联系人
        taxpayer: "", //供应商纳税人类型
        materialSources: "", //物资来源
        paymentCoefficient: "", //支付系数
        advanceCharge: "", //预付款
        titleAccount: "", //账户名称
        accountNumber: "", //开户行账号
        accountName: "" //开户行名称
      },
      rules: {},
      tableData: [
        {
          id: "1",
          textName: "采购清单.xlsx",
          txtlarge: "12Kb"
        }
      ],
      uploadUrl: this.$addUrlPerFix(process.env.VUE_APP_UPLOAD_URL), //上传图片
      headers: {
        Authorization: Cookies.get("access_token") || ""
      }
    };
  },
  methods: {},
  watch: {
    financeInfo() {
      this.form = this.financeInfo;
    }
  }
};
</script>

<style scoped lang="scss">
/deep/.el-table {
  /deep/th {
    padding: 0;
    heigth: 36px;
    line-height: 36px;
  }
  .el-table__body {
    .cell {
      height: 36px;
      line-height: 36px;
    }
  }
}
.appendixInfo {
  position: relative;
}
.extend-btn {
  position: absolute;
  top: -5px;
  right: 0;
}
</style>
